import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
// import { getLocale } from "react-i18nify";
import { useSnackbar } from "notistack";
import dayjs from "dayjs";

import { Avatar } from "@mui/material";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
// import InputAdornment from "@mui/material/InputAdornment";
// import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";

import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

import { getAdminList, removeAdmin } from "src/api/admin";

import { useAuth } from "src/hooks/useAuth";
import { checkNotEmpty } from "src/common";
import { useDialog } from "src/context/DialogContext";

import Main from "src/components/core/Main";
import Button from "src/components/core/Button";
import TextField from "src/components/core/TextField";
import Loading from "src/components/ui/Loading";

import AddAdminDialog from "src/modules/user-management/admin/modal/AddAdminDialog";

const DivMuiContainer = styled.div`
  width: 100%;
  height: auto;
  padding: 32px;
  border-radius: 32px;
  background-color: #ffffff;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  // display: flex;
  justify-content: center;
  align-items: center;
`;

const DivMuiInside = styled.div`
  width: 100%;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
`;

const WrapperSearch = styled.div`
  // margin-bottom: 32px;
  margin-right: 16px;
  width: 65%;
  position: relative;
  display: flex;
  justify-content: center;

  .TextField-without-border-radius fieldset {
    border-radius: 16px;
  }
  .MuiTextField-root {
    margin: 0;
  }
`;

const WrapperAddButton = styled.div`
  width: 35%;
  text-align: right;
`;

const WrapperDataGrid = styled.div`
  height: 600px;
  width: 100%;
  .MuiDataGrid-root {
    border: 1px solid #ffffff;
  }
  .MuiDataGrid-columnHeaders {
    background-color: #f5f5f5;
  }
  .MuiDataGrid-root .MuiDataGrid-columnSeparator--sideRight {
    color: #f5f5f5;
  }
  .MuiDataGrid-root .MuiDataGrid-columnHeader:focus-within {
    // outline: solid #f5f5f5 1px;
    outline: none;
  }
  .MuiDataGrid-root .MuiDataGrid-cell:focus {
    outline: none;
    border-bottom: solid #f5f5f5 1px 0 1px 0;
  }
  .MuiDataGrid-root .MuiDataGrid-row.Mui-selected {
    background-color: #ffffff;
  }
`;

const ImageNoData = styled.image`
  width: 120px;
  height: 120px;
  background-image: url("https://xsurface-images.s3.ap-southeast-1.amazonaws.com/no+data.svg");
  background-repeat: no-repeat;
  background-size: 100%;
`;
const ImageNotFound = styled.image`
  width: 120px;
  height: 120px;
  background-image: url("https://xsurface-images.s3.ap-southeast-1.amazonaws.com/not+found.svg");
  background-repeat: no-repeat;
  background-size: 100%;
`;

const TextNoData = styled.pre`
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
`;

function AdminList({ open }) {
  const { user, checkAllowPermission } = useAuth();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { openDialog, closeDialog, closeAllDialogs } = useDialog();

  const [adminList, setAdminList] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [dataSearch, setDataSearch] = useState({
    keyword: null,
    page: 0,
    page_size: 10,
    status: "all",
  });
  const [rowCount, setRowCount] = useState(0);

  const columns = [
    {
      field: "name",
      headerName: "User",
      flex: 3,
      // width: 200,
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <Box
            sx={{
              width: "100%",
              height: "100%",
              margin: "8px",
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              outline: "none",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            <Avatar
              src={params?.row?.user_profile_image}
              size={100}
              backgroundColor="rgba(0,0,0,0)"
              style={{ border: 0, marginRight: "4px" }}
            />
            <div style={{ margin: "8px", width: "50%" }}>
              <div
                className="MuiDataGrid-cellContent"
                style={{
                  margin: "5px auto",
                  fontSize: "0.875rem",
                  fontWeight: 500,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {params.row.name}
              </div>

              <div
                className="MuiDataGrid-cellContent"
                style={{
                  margin: "5px auto",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {params.row.email ? params.row.email : "-"}
              </div>
            </div>
          </Box>
        );
      },
    },
    {
      field: "createdAt",
      headerName: "Date Request",
      flex: 1,
      headerAlign: "center",
      align: "center",
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <div className="rowitem">
            {params?.row?.createdAt
              ? dayjs(params?.row?.createdAt).format("DD-MM-YYYY")
              : "-"}
          </div>
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      headerAlign: "center",
      align: "center",
      editable: false,
      sortable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        return (
          <div className="rowitem">{params.row.status ? "ใช้งาน" : " - "}</div>
        );
      },
    },
    {
      field: "actions",
      type: "actions",
      headerName: "",
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      getActions: (params) => [
        <GridActionsCellItem
          icon={<VisibilityIcon />}
          label="Detail"
          onClick={() => navigate(`/admin/detail/${params?.row?._id}`)}
          showInMenu
        />,
        <GridActionsCellItem
          icon={<DeleteOutlineIcon />}
          label="Remove"
          disabled={!checkAllowPermission("admins.can_delete")}
          onClick={() =>
            openDialog({
              type: "confirm",
              title: `คุณต้องการลบ Admin ใช่หรือไม่`,
              onConfirm: () => {
                handleRemoveAdmin(params?.row?._id);
              },
              maxWidth: 342,
            })
          }
          showInMenu
        />,
      ],
    },
  ];

  function NoRowsOverlay() {
    return (
      <Stack height="100%" alignItems="center" justifyContent="center">
        <ImageNoData></ImageNoData>
        <TextNoData>No Data</TextNoData>
      </Stack>
    );
  }

  function NoResultsOverlay() {
    return (
      <Stack height="100%" alignItems="center" justifyContent="center">
        <ImageNotFound></ImageNotFound>
        <TextNoData>Not Found</TextNoData>
      </Stack>
    );
  }

  const fetchAdminList = async () => {
    try {
      if (user.role_id === 1) {
        const data = await getAdminList(dataSearch);
        setAdminList(
          data.rows.map((user) => ({
            ...user,
            name:
              user.register_type === 1 // email-pwd
                ? checkNotEmpty(user?.first_name) &&
                  checkNotEmpty(user?.last_name)
                  ? `${user?.first_name} ${user?.last_name}`
                  : "-"
                : user.register_type === 2 // facebook
                  ? user.facebook_name
                  : user.register_type === 3 // google
                    ? user.google_name
                    : "-",
          })),
        );
        setRowCount(data.count);
      }
    } catch (err) {
      console.error("err:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleRemoveAdmin = async (id) => {
    try {
      setIsLoading(true);

      await removeAdmin(id);
      enqueueSnackbar(`Remove Admin Success!`, { variant: "success" });

      await fetchAdminList();
    } catch (err) {
      console.error("remove err:", err.response);
      enqueueSnackbar(err?.response?.data?.message, { variant: "error" });
    } finally {
      setIsLoading(false);
      closeAllDialogs();
    }
  };

  const onSearchButton = () => {
    setDataSearch({ ...dataSearch, page: 0 });
    fetchAdminList();
  };

  const handlePageChange = (newPage) => {
    setDataSearch({ ...dataSearch, page: newPage });
  };

  useEffect(() => {
    fetchAdminList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSearch.page, dataSearch.status]);

  return (
    <>
      <Main open={open}>
        <DivMuiContainer>
          <DivMuiInside>
            <WrapperSearch>
              <TextField
                id="search-input"
                placeholder="ค้นหาจากชื่อ หรืออีเมล"
                className="TextField-without-border-radius"
                sx={{
                  m: 1,
                  width: "100%",
                  borderRadius: "16px",
                }}
                InputProps={{
                  endAdornment: (
                    <IconButton
                      id="button-search-seller"
                      sx={{ padding: 0 }}
                      onClick={() => {
                        onSearchButton();
                      }}
                    >
                      <SearchIcon
                        sx={{ color: "#e04132", cursor: "pointer" }}
                      />
                    </IconButton>
                  ),
                }}
                onChange={(e) => {
                  setDataSearch({ ...dataSearch, keyword: e.target.value });
                }}
                onKeyUp={(e) => (e.code === "Enter" ? onSearchButton() : null)}
              />
            </WrapperSearch>

            {checkAllowPermission("admins.can_create") && (
              <WrapperAddButton>
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={() =>
                    openDialog({
                      type: "custom",
                      customDialog: (
                        <AddAdminDialog
                          setIsLoading={setIsLoading}
                          onClose={() => closeDialog()}
                          onSuccess={() => {
                            fetchAdminList();
                            closeAllDialogs();
                          }}
                        />
                      ),
                      maxWidth: 342,
                    })
                  }
                >
                  เพิ่ม Admin
                </Button>
              </WrapperAddButton>
            )}
          </DivMuiInside>

          <WrapperDataGrid>
            <DataGrid
              rows={adminList}
              getRowId={(row) => row._id}
              getRowHeight={() => "auto"}
              loading={isLoading}
              columns={columns}
              pageSize={10}
              rowCount={rowCount}
              paginationMode="server"
              page={dataSearch.page}
              onPageChange={(e) => handlePageChange(e)}
              rowsPerPageOptions={[10]}
              pagination
              disableSelectionOnClick
              // localeText={{
              //   footerRowSelected: CustomPagination,
              // }}
              components={{
                // Footer: CustomPagination,
                NoRowsOverlay,
                NoResultsOverlay,
              }}
              componentsProps={{
                basePopper: {},
              }}
              sx={{
                "& .MuiDataGrid-actionsCell": {
                  transform: "rotate(90deg)",
                },
              }}
            />
          </WrapperDataGrid>
        </DivMuiContainer>
      </Main>

      {isLoading && <Loading />}
    </>
  );
}

export default AdminList;
